export default __webpack_public_path__ + "static/media/banner_desativacao_portal_web.afdf2b9b.png";